import TYPES from './types';
import { getProfile } from '../../../api/client';

const loadingSearchToggle = () => ({
  type: TYPES.loadingFormSearch,
});

export const search = () => {
  return dispatch => {
    dispatch(loadingSearchToggle());

    getProfile()
      .then(response =>
        dispatch({
          type: TYPES.searchSuccess,
          payload: response,
        })
      )
      .then(() => dispatch(loadingSearchToggle()))
      .catch(() => dispatch({ type: TYPES.searchError }))
  }
};

export const setDefaultPageRules = () => ({
  type: TYPES.setDefaultPage,
});
